import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const TOKEN = localStorage.getItem('token');

export const schema = Joi.object().keys({
	sFirstName: Joi.string().required(),
	sLastName: Joi.string().required(),
	sNickName: Joi.string().allow(''),
	sGender: Joi.number().required(),
  sBirthday: Joi.string().allow(''),
  sPhone: Joi.string().required(),
  sHomePhone: Joi.string().allow('', NaN),
  sEmail: Joi.string().allow(''),
  sSource: Joi.string().allow(''),
  sSocialID: Joi.string().allow(''),
  sParentsName: Joi.string().allow(''),
  sGuardianRelation: Joi.string().allow(''),
  sCountry: Joi.string().allow(''),
  sProvince: Joi.string().allow(''),
  sCity: Joi.string().allow(''),
  sPostcode: Joi.string().allow(''),
  sAddress: Joi.string().allow(''),
	sSuitNumber: Joi.string().allow(''),
  sRemark: Joi.string().allow(''),
  sCreateTime: Joi.string().allow(''),

  custom_data: Joi.object(),
  photo: Joi.object(),

  sParentsName: Joi.string().allow(''),
  sGuardianRelation: Joi.string().allow(''),
  sParentsEmail: Joi.string().allow(''),
  sParentsPhone: Joi.string().allow(''),

  sParents2Name: Joi.string().allow(''),
  sGuardian2Relation: Joi.string().allow(''),
  sParents2Email: Joi.string().allow(''),
  sParents2Phone: Joi.string().allow(''),

});

export default function registerStudent(schoolId, studentInfo) {

  if(!schoolId){
    throw 'missing school ID'
  }

  let validateResult = Joi.validate(studentInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  let toServer = {
    ...studentInfo,
  }

	// this is to ensure that the error "Column ssAddress cannot be null, I'm not sure where the ssAddress is coming from..."
	delete toServer.ssAddress

  if (toServer.photo) {
    return updateWithUpload(schoolId, toServer);
  } else {
    return update(schoolId, toServer);
  }
}

function updateWithUpload(schoolId, toServer) {

  let API_URL
  if (process.env.APP_ENV == 'development') {
    API_URL = 'https://saas.classtop.com:3001/sapi';
  } else {
    API_URL = 'https://school.classtop.com:3001/sapi';
  }

  return new Promise((resolve, reject) => {
    let data = new FormData();
    
    _.each(toServer, (value, name)=>{
      if (name === 'photo') {
        data.append('photo', toServer.photo, 'photo');
      } else if (name === 'custom_data') { 
        data.append('custom_data', JSON.stringify(value));
      } else if (typeof value !== 'undefined') {
        data.append(name, value);
      }
    });

    axios.post(API_URL + '/rgst/' + schoolId + '/', data, {
      'onUploadProgress': (progress)=>{
        if (typeof onUploadProgress == 'function') {
          progress.ratio = progress.loaded / progress.total;
          onUploadProgress(progress);
        }
      },
      headers: {
        'Authorization': 'JWT ' + localStorage.getItem('token'),
        'Content-Type': 'multipart/form-data',
      }
    })
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
      console.error(err)
    });

  });

}


function update(schoolId, toServer) {
  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/rgst/${schoolId}/`, 'method': 'POST', 'data': JSON.stringify(toServer), 'token': TOKEN})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/registerStudent.js